import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ForPlacesPage() {
  const benefits = [
    {
      icon: 'ri-calculator-line',
      title: '謝金支払いを簡単に',
      description: '源泉徴収・消費税の計算サポートで、複雑な事務作業を自動化'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全面の相談がいつでも可能',
      description: '報告フォームで運営に直接相談。迅速なサポートを提供'
    },
    {
      icon: 'ri-settings-3-line',
      title: '登録も運用もシンプル',
      description: '最短で始められる設計。複雑な設定は不要'
    },
    {
      icon: 'ri-time-line',
      title: '運営の手間を削減',
      description: 'ボランティア管理や連絡調整の負担を軽減'
    }
  ];

  const features = [
    {
      title: '課題の画像・質問アップロード',
      description: '居場所スタッフが課題や質問をサービスに投稿。ボランティアが効率的に支援できる環境を提供',
      image: 'https://public.readdy.ai/ai/img_res/425cb064ebdee6e245878c8a133e6110.jpg'
    },
    {
      title: 'ボランティアからの支援申し出',
      description: 'アップロードされた課題に対して、ボランティアが支援を申し出。マッチングがスムーズに進行',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20volunteer%20using%20smartphone%20to%20respond%20to%20tutoring%20requests%20in%20Japanese%20home%20or%20cafe%20setting%2C%20notification%20interface%20showing%20available%20support%20opportunities%20on%20mobile%20screen%2C%20young%20Japanese%20person%20engaged%20with%20modern%20mobile%20app%20design%20for%20educational%20matching%2C%20warm%20and%20friendly%20atmosphere&width=400&height=300&seq=102&orientation=landscape'
    },
    {
      title: 'オンラインで授業開始',
      description: '最短1分で授業開始。オンライン環境で効率的な学習支援を実現',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20student%20and%20Japanese%20tutor%20having%20online%20tutoring%20session%20on%20laptop%20screen%20in%20Japanese%20room%2C%20video%20call%20interface%20showing%20both%20participants%2C%20educational%20materials%20shared%20digitally%20on%20screen%2C%20modern%20e-learning%20environment%20in%20Japan%20with%20natural%20lighting%2C%20friendly%20and%20supportive%20atmosphere&width=400&height=300&seq=103&orientation=landscape'
    }
  ];

  const supportFeatures = [
    {
      title: '柔軟な参加スタイル',
      description: '1対1のオンライン、みんなでオンライン、1つの画面をみんなで見る形式など、多様な学習スタイルに対応',
      icon: 'ri-group-line'
    },
    {
      title: '謝金の支払いがラク',
      description: '謝金ポイントは必要な分だけ事前購入。使いすぎの心配なし。授業が終わったらボランティアにポイントが渡される',
      icon: 'ri-coin-line'
    },
    {
      title: '学習履歴の出力',
      description: '子どもたちの学習状況を月単位で確認・出力可能。保護者への報告や活動記録として活用できます',
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-20 pb-16 px-4 bg-gradient-to-br from-teal-50 to-blue-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                運営の手間を減らして、<br />
                子どもと向き合う時間を。
              </h1>
              <p className="text-lg text-gray-600 mb-4 leading-relaxed">
                ボラタスは居場所の運営者様の負担を軽減し、本来の支援活動に集中できる環境を提供します。
                課題アップロードから授業開始まで、わずか1分で学習支援が始まります。
              </p>
              <p className="text-base text-teal-700 mb-8 leading-relaxed font-medium">
                居場所の現場は人手不足・時間不足になりがち。だからこそ、運営の負担を減らすことが、こどもに向き合う余白を生み出します。
              </p>
              <a 
                href="https://boratasu.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                サービスを使ってみる
              </a>
            </div>
            <div className="lg:text-right">
              <img 
                src="https://readdy.ai/api/search-image?query=caring%20Japanese%20teacher%20or%20counselor%20working%20warmly%20with%20Japanese%20children%20in%20learning%20support%20center%20in%20Japan%2C%20warm%20and%20welcoming%20environment%20with%20natural%20wood%20furniture%2C%20educational%20setting%20with%20books%20and%20learning%20materials%2C%20natural%20soft%20lighting%20streaming%20through%20windows%2C%20professional%20yet%20friendly%20atmosphere%2C%20Japanese%20cultural%20elements%20subtly%20present%2C%20genuine%20smiles%20and%20supportive%20interaction&width=600&height=400&seq=104&orientation=landscape"
                alt="学習支援の現場で子どもたちと向き合う支援員"
                className="rounded-2xl shadow-lg object-cover w-full h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            居場所運営者様のメリット
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            はじめかた　3ステップ
          </h2>
          <p className="text-center text-gray-600 mb-12">最短1分で授業開始</p>
          <div className="space-y-16">
            {features.map((feature, index) => (
              <div key={index} className={`grid lg:grid-cols-2 gap-8 items-center ${index % 2 === 1 ? 'lg:grid-flow-col-dense' : ''}`}>
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-8 h-8 bg-teal-600 text-white rounded-full flex items-center justify-center text-sm font-bold">
                      {index + 1}
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{feature.title}</h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-lg">{feature.description}</p>
                </div>
                <div className={index % 2 === 1 ? 'lg:col-start-1' : ''}>
                  <img 
                    src={feature.image}
                    alt={feature.title}
                    className="rounded-xl shadow-lg object-cover w-full h-64"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Support Features Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            続けやすい　3つの仕組み
          </h2>
          <p className="text-center text-gray-600 mb-12">
            支援者が助かると、こどもに向き合う余白が増える。その余白が、こどもの学びや安心につながります。
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            {supportFeatures.map((feature, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-blue-500 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${feature.icon} text-xl text-white`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Flexible Learning Styles Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            柔軟な参加スタイル
          </h2>
          <p className="text-center text-gray-600 mb-12">
            子どもたちの学習状況や居場所の環境に合わせて、3つのスタイルから選択できます
          </p>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/e9a1140f3e10880e909349090f0e0894.png"
                alt="3つの学習スタイル：1対1、みんなでオンライン、1画面をみんなで"
                className="rounded-xl shadow-lg object-cover w-full"
              />
            </div>
            <div className="space-y-8">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">1対1オンライン</h3>
                    <p className="text-gray-600 leading-relaxed">
                      個別指導が必要な子どもに最適。ボランティアと1対1でじっくり学習に取り組めます。集中して質問しやすい環境です。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-group-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">みんなでオンライン</h3>
                    <p className="text-gray-600 leading-relaxed">
                      複数の子どもたちが同時にオンライン参加。お互いに刺激し合いながら学習でき、協調性も育まれるスタイルです。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-tv-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">1画面をみんなで</h3>
                    <p className="text-gray-600 leading-relaxed">
                      居場所の大きなスクリーンに映して、みんなで一緒に学習。一体感のある学習環境で、楽しく取り組めます。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Payment Methods Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            安全で便利な支払い方法
          </h2>
          <p className="text-center text-gray-600 mb-12">
            必要な分だけ事前購入で、使いすぎの心配なし。複数の支払い方法に対応しています
          </p>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/bf3389c08b6cce7db90742892fb1583e.png"
                alt="ポイント購入画面と支払い方法"
                className="rounded-xl shadow-lg object-cover w-full"
              />
            </div>
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shopping-cart-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">必要な分だけ事前購入</h3>
                    <p className="text-gray-600 leading-relaxed">
                      600P（15分）から24,000P（10時間）まで、利用予定に合わせて必要な分だけポイントを購入できます。使いすぎの心配がありません。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Stripeを介した安全な決済</h3>
                    <p className="text-gray-600 leading-relaxed">
                      世界中で信頼されているStripe決済システムを採用。お客様のカード情報は暗号化され、安全に処理されます。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-bank-card-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">多様な支払い方法</h3>
                    <p className="text-gray-600 leading-relaxed mb-3">
                      お客様のご都合に合わせて、複数の支払い方法からお選びいただけます：
                    </p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>クレジットカード</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>デビットカード</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>銀行振込</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-time-line text-orange-500"></i>
                        <span>コンビニ決済（現在準備中）</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Learning History Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            学習履歴の出力機能
          </h2>
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                月単位での学習記録を簡単出力
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed">
                子どもたちの学習状況を月単位で詳細に記録・出力できます。学習時間、取り組んだ教科、学習内容などを一覧で確認でき、保護者への報告書や活動実績の記録として活用いただけます。
              </p>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>学習日時と時間の詳細記録</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>教科別の学習内容と進捗</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>ボランティア講師からのコメント</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>PDF形式での出力・印刷対応</span>
                </li>
              </ul>
            </div>
            <div>
              <img 
                src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/a065904c1ba909d469ab18c8cf6dd168.png"
                alt="月単位の学習履歴レポート"
                className="rounded-xl shadow-lg object-cover w-full h-80"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Flexible Usage Section */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            柔軟な使い方ができるボラタス
          </h2>
          <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm mb-12">
            <p className="text-lg text-gray-700 text-center mb-6">
              1日の居場所利用時間の中で、学習に取り組む時間だけ活用する事で、コストを抑える事ができる。<br />
              例えば、5時間開室してる中で学習に取り組むのが2時間なら、その時間だけ活用したり、30分単位に分けて、初めの1時間と終わりの1時間など柔軟な活用方法が可能です。
            </p>
          </div>

          <h3 className="text-xl font-bold text-center text-gray-900 mb-4">
            必要な経費の比較
          </h3>
          <p className="text-center text-gray-600 mb-8">
            ここでは、5教科分の常勤スタッフを確保した場合のコストと、ボラタスを使った場合を比較しています。
          </p>
          
          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm overflow-x-auto">
            <h4 className="text-lg font-bold text-gray-900 mb-6 text-center">
              月額コスト比較(拠点あたり・22日稼働・5教科想定)
            </h4>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-gray-200">
                    <th className="text-left py-3 px-2 font-semibold text-gray-900">区分</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">稼働</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">月間時間</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">直接支出</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">法定負担</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">求人費</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">管理費</th>
                    <th className="text-center py-3 px-2 font-semibold text-gray-900">月合計</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-100 bg-teal-50">
                    <td className="py-4 px-2 font-semibold text-teal-700">サービス利用</td>
                    <td className="py-4 px-2 text-center">2時間/日</td>
                    <td className="py-4 px-2 text-center">44 h</td>
                    <td className="py-4 px-2 text-center">2,400×44 = 105,600</td>
                    <td className="py-4 px-2 text-center">—</td>
                    <td className="py-4 px-2 text-center">0</td>
                    <td className="py-4 px-2 text-center">0</td>
                    <td className="py-4 px-2 text-center font-semibold text-teal-700">105,600</td>
                  </tr>
                  <tr className="border-b border-gray-100">
                    <td className="py-4 px-2">雇用(社保なし)</td>
                    <td className="py-4 px-2 text-center">5時間/日 × 5教科</td>
                    <td className="py-4 px-2 text-center">550 h</td>
                    <td className="py-4 px-2 text-center">1,500×550 = 825,000</td>
                    <td className="py-4 px-2 text-center">+0.9% = 7,425</td>
                    <td className="py-4 px-2 text-center">100,000</td>
                    <td className="py-4 px-2 text-center">50,000</td>
                    <td className="py-4 px-2 text-center font-semibold">982,425</td>
                  </tr>
                  <tr>
                    <td className="py-4 px-2">雇用(社保あり)</td>
                    <td className="py-4 px-2 text-center">5時間/日 × 5教科</td>
                    <td className="py-4 px-2 text-center">550 h</td>
                    <td className="py-4 px-2 text-center">1,500×550 = 825,000</td>
                    <td className="py-4 px-2 text-center">+15% = 123,750</td>
                    <td className="py-4 px-2 text-center">100,000</td>
                    <td className="py-4 px-2 text-center">50,000</td>
                    <td className="py-4 px-2 text-center font-semibold">1,098,750</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Multiple Subjects Support Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
              ボラタスなら複数の教科に対応可能
            </h2>
            <p className="text-lg text-gray-600">
              各教科の学習支援スタッフを常時雇用するよりもコストを抑えられる
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">従来の雇用方式</h3>
                  <p className="text-gray-600">各教科ごとにスタッフを雇用</p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <span>国語・数学・英語・理科・社会の各教科に専門スタッフが必要</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <span>5教科分の人件費が常時発生</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <span>各スタッフの求人・採用・管理コストが必要</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-close-circle-line text-red-500 mt-1"></i>
                  <span>需要の少ない教科でも固定費が発生</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 shadow-sm border-2 border-teal-200">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-smartphone-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">ボラタス</h3>
                  <p className="text-teal-700 font-semibold">必要な時に必要な教科だけ</p>
                </div>
              </div>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>全教科に対応可能なボランティアが登録済み</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>実際に利用した教科・時間分だけの支払い</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>求人・採用・管理コストが不要</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 mt-1"></i>
                  <span>需要に応じて柔軟に教科を選択可能</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
              対応可能な教科・分野
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-book-open-line text-xl text-white"></i>
                </div>
                <p className="font-semibold text-gray-900">国語</p>
              </div>
              <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-calculator-line text-xl text-white"></i>
                </div>
                <p className="font-semibold text-gray-900">数学</p>
              </div>
              <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-english-input text-xl text-white"></i>
                </div>
                <p className="font-semibold text-gray-900">英語</p>
              </div>
              <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-test-tube-line text-xl text-white"></i>
                </div>
                <p className="font-semibold text-gray-900">理科</p>
              </div>
              <div className="text-center p-4 bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-earth-line text-xl text-white"></i>
                </div>
                <p className="font-semibold text-gray-900">社会</p>
              </div>
            </div>
            <p className="text-center text-gray-600 mt-6">
              その他、プログラミング、音楽、美術、体育など、様々な分野に対応可能なボランティアが登録しています
            </p>
          </div>
        </div>
      </section>

      {/* Volunteer Certificate Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-4">
            ボランティアへの証明書発行も簡単
          </h2>
          <p className="text-center text-gray-600 mb-12">
            ボランティアの方々に発行するボランティア証明書もサービスで簡単作成
          </p>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/8766ff501ca5aa7943b16e981fd86369/99af8b64f9ea584043aff2a85612ded4.png"
                alt="ボランティア証明書のサンプル"
                className="rounded-xl shadow-lg object-cover w-full"
              />
            </div>
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-blue-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-file-text-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">居場所側は操作不要</h3>
                    <p className="text-gray-600 leading-relaxed">
                      ボランティア証明書の発行は、居場所側で特別な操作をする必要がありません。ボランティアの方が自分の画面から簡単に発行できる仕組みになっています。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-smartphone-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">ボランティア側で簡単発行</h3>
                    <p className="text-gray-600 leading-relaxed">
                      ボランティアの方は、サービス内の自分の画面から必要な時にいつでも証明書を発行できます。活動実績が自動的に記録されているため、正確な証明書が即座に作成されます。
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-double-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">正確な活動記録</h3>
                    <p className="text-gray-600 leading-relaxed mb-3">
                      証明書には以下の情報が自動的に記載されます：
                    </p>
                    <ul className="space-y-2 text-sm text-gray-600">
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>支援期間（開始日〜終了日）</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>支援人数（実数）</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>総支援回数</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <i className="ri-check-line text-teal-600"></i>
                        <span>総支援時間</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-12">
            利用者の声
          </h2>
          <div className="space-y-6">
            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-double-quotes-l text-2xl text-teal-600"></i>
                </div>
                <blockquote className="text-lg text-gray-700 mb-6 italic">
                  「課題をアップロードするだけで、すぐにボランティアの方が支援してくれる。子どもたちとの時間をもっと大切にできるようになりました。」
                </blockquote>
                <cite className="text-gray-600">— 学習支援センター運営者様</cite>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-double-quotes-l text-2xl text-teal-600"></i>
                </div>
                <blockquote className="text-lg text-gray-700 mb-6 italic">
                  「5教科だけでなく、ダンスや楽器のレッスンなど習い事にも活用できるのが良いです。利用者の中にはそういった特技を持つ子もいるので、利用者が他の居場所へのボランティアをするなど色々と活用を検討しています。」
                </blockquote>
                <cite className="text-gray-600">— 居場所運営者様</cite>
              </div>
            </div>

            <div className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-double-quotes-l text-2xl text-teal-600"></i>
                </div>
                <blockquote className="text-lg text-gray-700 mb-6 italic">
                  「人件費確保の課題があり、学習支援をしたくても長時間の雇用が難しかったです。このサービスなら、こどもたちからの要望があった時に使えて、月の利用額を管理者側で設定できるので、安心して運用できます。」
                </blockquote>
                <cite className="text-gray-600">— 子ども食堂運営者様</cite>
              </div>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-purple-50 border border-blue-200 rounded-2xl p-8 shadow-sm">
              <div className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-double-quotes-l text-2xl text-white"></i>
                </div>
                <div className="inline-block bg-blue-600 text-white text-sm font-semibold px-4 py-1 rounded-full mb-4">
                  ボランティアの声
                </div>
                <blockquote className="text-lg text-gray-700 mb-6 italic">
                  「ボランティアをしたくても、教職の授業を取っていてコマ数が多く、1日中学校にいる必要がありました。空きコマがあっても遠くまでは移動する事が出来ないので、学業と両立できるこのサービスは友達にも紹介して活用したいです。」
                </blockquote>
                <cite className="text-gray-600">— 大学生ボランティア</cite>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-4 bg-gradient-to-r from-teal-500 to-blue-500">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-2xl md:text-3xl font-bold mb-6">
            今すぐ始めて、運営をもっと楽に
          </h2>
          <p className="text-lg mb-8 opacity-90">
            登録は無料です。まずはお試しください。
          </p>
          <div className="text-center">
            <a 
              href="https://boratasu.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors text-lg font-semibold whitespace-nowrap cursor-pointer inline-block"
            >
              サービスを使ってみる
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
